/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as SplatRouteImport } from './routes/$'
import { Route as IndexRouteImport } from './routes/index'
import { Route as IdSummariseRouteImport } from './routes/$id/summarise'
import { Route as IdSuggestionsRouteImport } from './routes/$id/suggestions'

const SplatRoute = SplatRouteImport.update({
  id: '/$',
  path: '/$',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const IdSummariseRoute = IdSummariseRouteImport.update({
  id: '/$id/summarise',
  path: '/$id/summarise',
  getParentRoute: () => rootRouteImport,
} as any)
const IdSuggestionsRoute = IdSuggestionsRouteImport.update({
  id: '/$id/suggestions',
  path: '/$id/suggestions',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/$': typeof SplatRoute
  '/$id/suggestions': typeof IdSuggestionsRoute
  '/$id/summarise': typeof IdSummariseRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/$': typeof SplatRoute
  '/$id/suggestions': typeof IdSuggestionsRoute
  '/$id/summarise': typeof IdSummariseRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/$': typeof SplatRoute
  '/$id/suggestions': typeof IdSuggestionsRoute
  '/$id/summarise': typeof IdSummariseRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths: '/' | '/$' | '/$id/suggestions' | '/$id/summarise'
  fileRoutesByTo: FileRoutesByTo
  to: '/' | '/$' | '/$id/suggestions' | '/$id/summarise'
  id: '__root__' | '/' | '/$' | '/$id/suggestions' | '/$id/summarise'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  SplatRoute: typeof SplatRoute
  IdSuggestionsRoute: typeof IdSuggestionsRoute
  IdSummariseRoute: typeof IdSummariseRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/$': {
      id: '/$'
      path: '/$'
      fullPath: '/$'
      preLoaderRoute: typeof SplatRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/$id/summarise': {
      id: '/$id/summarise'
      path: '/$id/summarise'
      fullPath: '/$id/summarise'
      preLoaderRoute: typeof IdSummariseRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/$id/suggestions': {
      id: '/$id/suggestions'
      path: '/$id/suggestions'
      fullPath: '/$id/suggestions'
      preLoaderRoute: typeof IdSuggestionsRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  SplatRoute: SplatRoute,
  IdSuggestionsRoute: IdSuggestionsRoute,
  IdSummariseRoute: IdSummariseRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
